import styled from 'styled-components';

import { Table } from 'components/common';

export const AuthPanel = styled.div`
  margin-top: ${p => p.theme.gutter};
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    max-width: 120px;
    max-height: 60px;
    object-fit: contain;
    filter: grayscale(100%);
    margin-bottom: ${p => p.theme.gutter};
  }
`;

export const ConnectionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: ${p => p.theme.gutter};
  margin-top: ${p => p.theme.gutter};
`;

export const ConnectionCard = styled.div`
  border: 1px solid ${p => p.theme.lightGrey};
  border-radius: 4px;
  padding: ${p => p.theme.gutter};
  background: white;
  display: flex;
  flex-direction: column;
`;

export const ConnectionCardLogoContainer = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 16px;
  img {
    max-width: 120px;
    max-height: 60px;
    width: auto;
    height: auto;
    object-fit: contain;
  }
`;

export const ConnectionCardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  flex: 1;
`;

export const ConnectionCardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${p => p.theme.darkGrey || p.theme.black};
  margin: 0 0 8px 0;
  width: 100%;
`;

export const ConnectionCardDescription = styled.p`
  font-size: 14px;
  color: ${p => p.theme.grey || '#666'};
  line-height: 1.5;
  margin: 0 0 ${p => p.theme.gutter} 0;
`;

export const ConnectionCardActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: auto;
  padding-top: ${p => p.theme.gutter};
  gap: 12px;
`;

export const ConnectionCardButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const LearnMoreLink = styled.a`
  color: ${p => p.theme.blue || '#1890ff'};
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const StyledTable = styled(Table)`
  margin-top: ${p => p.theme.gutter};
`;

export const ColoredField = styled.div`
  color: ${p => (p.isDefault ? p.theme.grey : p.theme.black)};
`;

export const ModalContent = styled.div`
  display: flex;
`;

export const FieldOptions = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow-y: scroll;
  flex: 1;
`;

export const FieldOption = styled.div`
  padding: 5px 10px;
  margin-right: 15px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.1s linear;
  svg {
    margin-left: 10px;
    transition: all 0.1s linear;
    opacity: 0;
  }
  .name {
    font-weight: 500;
  }
  .description {
    font-size: 11px;
  }
  :hover {
    background: rgba(0, 0, 0, 0.05);
    svg {
      opacity: 1;
    }
  }
`;
